<template>

	<div id="allmap" :style="{ height: height + 'px'}" class="map-view"></div>

</template>
<script>
	import 'animate.css'
	import axios from 'axios'
	import {
		baseurl,
		url
	} from '../../api/url'

	var iconRed = require('../../assets/images/icon_red.png')
	var iconGreen = require('../../assets/images/icon_green.png')
	var iconGray = require('../../assets/images/icon_gray.png')
	var iconYellow = require('../../assets/images/icon_yellow.png')
	export default {
		methods: {
			rqsPath() {
				// G011746020000
				this.$terHisPath(this.mapdata1.sn, (res) => {
					// console.log(res.data)

					this.initPath(res.data)
				}, (error) => {

				})
			},
			showPolyLine(points, color, map) {
				/* points[][]数据结构为二维数组，这里转换为Marker，再将多个marker点放入pline，组成一条线  begin */
				var pLine = [];
				for (var i = 0; i < points.length; i++) {
					var obj = points[i]
					var lon = obj.longitude
					var lat = obj.latitude
					pLine.push(new AMap.LngLat(lon, lat))
					var marker = new AMap.Marker(new AMap.LngLat(lon, lat))

					if (i === 0) {
						var icon = new AMap.Icon(iconGreen, new AMap.Size(40, 40))
						marker.setIcon(icon)
					}

					marker.addEventListener('click', function(e) {
						var p = e.target
						var point = new AMap.LngLat(p.getPosition().lng, p.getPosition().lat)
						var sobj = ''
						points.forEach((vl) => {
							if (vl.latitude == point.lat && vl.longitude == point.lng) {
								sobj = vl
							}
						})
						var mct = sobj.locatime + '<br/><br/>' + sobj.address

						var infoWindow = new AMap.InfoWindow(mct, this.opts1)
						map.openInfoWindow(infoWindow, point)
					})

					map.add(marker)
				}
				/* points[][]数据结构为二维数组，这里转换为Marker，再将多个marker点放入pline，组成一条线  end */
				/* 添加轨迹接口begin */
				var polyline = new AMap.Polyline(pLine, {
					strokeColor: color,
					strokeWeight: 6,
					strokeOpacity: 0.5
				});
				// map.enableScrollWheelZoom();
				map.add(polyline)

			},
			initPath(paths) {
				// console.log(paths)
				if (paths.length === 0) {
					const map = new AMap.Map('allmap', {
						// enableMapClick: false,
						resizeEnable: true,
						viewMode: '3D',
						pinch: 45
					})
					AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar', ], function() {
						map.addControl(new AMap.ControlBar({
							position: "RT" // 固定右上角
						}));
						map.addControl(new AMap.ToolBar({
							// 简易缩放模式，默认为 false
							liteStyle: true,
							position: "RT", // 固定右上角
							offset: [30, 110] //偏移量 x,y轴
						}));
					});

					map.setZoomAndCenter(15, [108.960679, 34.314287]); //同时设置地图层级与中心点
					var size = new AMap.Size(20, 20)
					return
				}

				const map = new AMap.Map('allmap', {
					// enableMapClick: false
				})

				map.setZoomAndCenter(15, [paths[0].longitude, paths[0].latitude]); //同时设置地图层级与中心点
				this.showPolyLine(paths, "red", map);
			},
			terminalAreaReport() {
				const map = new AMap.Map('allmap', {
					// enableMapClick: false  // 禁用弹出景点信息，高德地图没这东西
					resizeEnable: true,
					viewMode: '3D',
					pinch: 45
				})
				// 添加 3D 罗盘控制、缩放按钮
				AMap.plugin(['AMap.ControlBar', 'AMap.ToolBar', ], function() {
					map.addControl(new AMap.ControlBar({
						position: "RT" // 固定右上角
					}));
					map.addControl(new AMap.ToolBar({
						// 简易缩放模式，默认为 false
						liteStyle: true,
						position: "RT", // 固定右上角
						offset: [30, 110] //偏移量 x,y轴
					}));
				});
				map.setZoomAndCenter(5, [108.960679, 34.314287]); //同时设置地图层级与中心点
				// 高德地图没城市选择控件
				// var size = new AMap.Size(20, 20)
				// map.addControl(new AMap.CityListControl({
				// 	position: 'LT',
				// 	offset: size
				// }))


				let self = this

				var tno = self.mapdata1.sn ? self.mapdata1.sn : ''
				var mc = self.mapdata1.areaid ? self.mapdata1.areaid : ''

				var params = {
					page: self.mapdata1.page,
					rows: self.mapdata1.rows,
					areaid: mc,
					terminal_no: tno,
					terminal_status: self.mapdata1.status,
					terminal_runtime_status: self.mapdata1.runStatus
				}


				axios.post(`${baseurl}/terminal/list.do`, params).then(function(response) {
					let status = response.data.status
					if (status == 200) {
						self.mapdata = response.data.data
						var carr = self.mapdata[0]

						if (carr && self.mapdata1.sn) {
							carr = carr.coordinate.split(',')
							
							
							// --------------
							// 百度地图点转高德地图点
							var bd_lng = carr[0]
							var bd_lat = carr[1]
							var x_pi = Math.PI * 3000.0 / 180.0
							var x = bd_lng - 0.0065,
								y = bd_lat - 0.006;
							var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
							var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
							var gd_lng = z * Math.cos(theta);
							var gd_lat = z * Math.sin(theta);
							carr[0] = gd_lng;
							carr[1] = gd_lat;
							// --------------
							
							map.setZoomAndCenter(15, [carr[0], carr[1]]); // 同时设置地图层级与中心点
						} else {

						}


						//console.log(self.mapdata)
						for (var i = 0; i < self.mapdata.length; i++) {
							var rs = self.mapdata[i];
							var terminalStatus;
							var terminalRuntimeStatus;
							if (rs.terminalStatus === '1') {
								terminalStatus = self.$t('lin_global.online')
							} else if (rs.terminalStatus === '2') {
								terminalStatus = self.$t('lin_global.offline')
							} else if (rs.terminalStatus === '3') {
								terminalStatus = self.$t('app_sleep')

							}

							var text = '<span style="line-height:20px;font-size:14px;">' + self.$t(
									'lin_global.label_no') + '：' + rs.terminalNo + '<br>' + self.$t(
									'lin_global.label_name') + '：' + rs.terminalName + '<br>' + self.$t(
									'lin_global.label_areaid_name') + '：' + rs.mechName + '<br>' + self.$t(
									'lin_global.label_address') + '：' + rs.currentAddress + '<br>' + self.$t(
									'lin_global.wlzt') + '：' + terminalStatus + '</br>' + '<br><a href="' +
								'./#/terList/' + rs.terminalId + '/details" style="float:right;">' + self.$t(
									'lin_global.ckxq') + '</a></span>'
							//'<span style="line-height:20px;font-size:14px;">'+self.$t('lin_global.label_no')+'：' + rs.terminalNo + '<br>'+self.$t('lin_global.label_name')+'：' + rs.terminalName + '<br>'+self.$t('lin_global.label_areaid_name')+'：' + rs.mechName + '<br>'+self.$t('lin_global.label_address')+'：' + rs.currentAddress + '<br>'+self.$t('lin_global.wlzt')+'：' + terminalStatus + '</br>'+self.$t('lin_global.run_status')+'：' + terminalRuntimeStatus + '<br><a href="/#/terList/' + rs.terminalId + '/details" style="float:right;">'+self.$t('lin_global.ckxq')+'</a></span>'
							var online = false
							var offline = false
							var fault = false
							var warn = false


							if (rs.terminalStatus === '1') {
								online = true
							}
							if (rs.terminalStatus === '2') {
								offline = true
							}
							if (rs.terminalStatus === '3') {
								warn = true
								//offline = true

							}

							var $location = rs.coordinate;
							self.geocoder(map, $location, text, online, offline, fault, warn)
						}
					}
				});
			},
			geocoder(map, city, text, online, offline, fault, warn) {
				// 百度地图点转高德地图点
				var bd_lng = city.split(',')[0]
				var bd_lat = city.split(',')[1]
				var x_pi = Math.PI * 3000.0 / 180.0
				var x = Number(bd_lng - 0.0065),
					y = Number(bd_lat - 0.006);
				var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
				var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
				var gd_lng = Number(z * Math.cos(theta))
				var gd_lat = Number(z * Math.sin(theta))
				//--------------
				
				var location = {}
				location.lng = gd_lng
				location.lat = gd_lat
				var marker = new AMap.Marker({
					// position: new AMap.LngLat(location.lng, location.lat),
					position: [location.lng, location.lat],
				});
				var content = text
				var pt = {
					lng:location.lng,
					lat:location.lat
				}
				let self = this

				function ComplexCustomOverlay(point, text, mouseoverText, type) {
					// console.log(1564867687)
					this.type = type
					this._point = point
					this._text = text
					this._overText = mouseoverText
					if (type === 0) {
						this.bgc = '#20A0FF'
						this.bg = "url('" + iconGreen + "')"
						this.OffsetLeft = -4
						this.OffsetTop = -5
						this.zIndex = 90
					}
					if (type === 1) {
						this.bgc = '#595959'
						this.bg = "url('" + iconGray + "')"
						this.OffsetLeft = -5
						this.OffsetTop = -5
						this.zIndex = 60
					}
					if (type === 3) {
						this.bgc = 'yellow'
						this.bg = "url('" + iconYellow + "')"
						this.OffsetLeft = -5
						this.OffsetTop = -5
						this.zIndex = 80
					}
					if (type === 2) {
						this.bgc = 'yellow'
						this.bg = "url('" + iconYellow + "')"
						this.OffsetLeft = -5
						this.OffsetTop = -5
						this.zIndex = 70
					}
				}
				// ComplexCustomOverlay.prototype = new AMap.Marker()
				// ComplexCustomOverlay.prototype.initialize = function(map) {
				// 	this._map = map
				// 	var div = this._div = document.createElement('div')
				// 	div.style.position = 'absolute'
				// 	div.style.zIndex = AMap.Overlay.getZIndex(this._point.lat)
				// 	div.style.backgroundColor = this.bgc
				// 	div.style.background = this.bg
				// 	div.style.zIndex = this.zIndex
				// 	div.style.color = 'white'
				// 	div.style.width = '20px'
				// 	div.style.height = '25px'
				// 	div.style.lineHeight = '25px'
				// 	div.style.whiteSpace = 'nowrap'
				// 	div.style.MozUserSelect = 'none'
				// 	div.style.fontSize = '10px'
				// 	div.style.cursor = 'pointer'
				// 	var span = this._span = document.createElement('span')
				// 	div.appendChild(span)
				// 	span.appendChild(document.createTextNode(this._text))
				// 	var that = this

				// 	div.onmouseover = function() {
				// 		this.style.width = '20px'
				// 		this.style.height = '25px'
				// 	}
				// 	var _Point = this._point
				// 	div.onclick = function(e) {
				// 		var infoWindow = new AMap.InfoWindow(content, this.opts)
				// 		map.openInfoWindow(infoWindow, _Point)
				// 	}
				// 	div.onmouseout = function() {
				// 		this.style.width = '20px'
				// 		this.style.height = '25px'
				// 	}
				// 	map.getPanes().labelPane.appendChild(div)
				// 	return div
				// }
				// ComplexCustomOverlay.prototype.draw = function() {
				// 	var map = this._map
				// 	var pixel = map.pointToOverlayPixel(this._point)
				// 	this._div.style.left = pixel.x + this.OffsetLeft + 'px'
				// 	this._div.style.top = pixel.y + this.OffsetTop + 'px'
				// }

				var txt = ''
				var mouseoverTxt = '12312312312'

				//fault = false
				//warn = false
				if (fault === true) {
					console.log("添加默认标点")
					// var myCompOverlay2 = new ComplexCustomOverlay(pt, '', mouseoverTxt, 2)
					// var icon = new AMap.Icon({
					// 	size: new AMap.Size(20, 24), //图标大小
					// 	image: require('../../assets/images/icon_gray.png'),
					// 	imageSize: new AMap.Size(20, 24)
					// });
					// marker = new AMap.Marker({
					// 	icon: icon,
					// 	position: new AMap.LngLat(myCompOverlay2._point.lng, myCompOverlay2._point.lat),
					// 	offset: [myCompOverlay2.OffsetLeft, myCompOverlay2.OffsetTop], //偏移量 x,y轴
					// 	zIndex: myCompOverlay2.zIndex,
					// });
					// map.add(marker)
					// map.add(myCompOverlay2)
				} else if (warn === true) {
					var myCompOverlay3 = new ComplexCustomOverlay(pt, '', mouseoverTxt, 3)
					var icon = new AMap.Icon({
						size: new AMap.Size(20, 24), //图标大小
						image: require('../../assets/images/icon_yellow.png'),
						imageSize: new AMap.Size(20, 24)
					});
					marker = new AMap.Marker({
						icon: icon,
						position: [myCompOverlay3._point.lng,myCompOverlay3._point.lat],
						offset: [myCompOverlay3.OffsetLeft, myCompOverlay3.OffsetTop], //偏移量 x,y轴
						zIndex: myCompOverlay3.zIndex,
					});
					map.add(marker)
					marker.content = content
					marker.on('click', function(e) {
						var infoWindow = new AMap.InfoWindow()
						infoWindow.setContent(content);
						infoWindow.open(map, e.target.getPosition());
					})
				} else if (offline === true) {
					var myCompOverlay1 = new ComplexCustomOverlay(pt, '', mouseoverTxt, 1)
					var icon = new AMap.Icon({
						size: new AMap.Size(20, 24), //图标大小
						image: require('../../assets/images/icon_gray.png'),
						imageSize: new AMap.Size(20, 24)
					});
					marker = new AMap.Marker({
						icon: icon,
						position: [myCompOverlay1._point.lng,myCompOverlay1._point.lat],
						offset: [myCompOverlay1.OffsetLeft, myCompOverlay1.OffsetTop], //偏移量 x,y轴
						zIndex: myCompOverlay1.zIndex,
					});
					map.add(marker)
					marker.content = content
					marker.on('click', function(e) {
						console.log(e)
						var infoWindow = new AMap.InfoWindow()
						infoWindow.setContent(content);
						infoWindow.open(map, e.target.getPosition());
					})
				} else if (online === true) {
					var myCompOverlay = new ComplexCustomOverlay(pt, '', mouseoverTxt, 0)
					var icon = new AMap.Icon({
						size: new AMap.Size(20, 24), //图标大小
						image: require('../../assets/images/icon_green.png'),
						imageSize: new AMap.Size(20, 24)
					});
					marker = new AMap.Marker({
						icon: icon,
						position: [myCompOverlay._point.lng,myCompOverlay._point.lat],
						offset: [myCompOverlay.OffsetLeft, myCompOverlay.OffsetTop], //偏移量 x,y轴
						zIndex: myCompOverlay.zIndex,
					});
					map.add(marker)
					marker.content = content
					marker.on('click', function(e) {
						var infoWindow = new AMap.InfoWindow()
						infoWindow.setContent(content);
						infoWindow.open(map, e.target.getPosition());
					})
				}

			},
			get_lng_lat(bd_lng, bd_lat) {
				// --------------
				// 百度地图点转高德地图点
				var x_pi = Math.PI * 3000.0 / 180.0
				var x = Number(bd_lng - 0.0065),
					y = Number(bd_lat - 0.006);
				var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
				var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
				var gd_lng = Number(z * Math.cos(theta))
				var gd_lat = Number(z * Math.sin(theta))
				var result_form = {
					gd_lng: gd_lng,
					gd_lat: gd_lat
				}
				return result_form
				// --------------
			},
			addClickHandler(content, marker) {
				marker.addEventListener('click', function(e) {
					this.openInfo(content, e)
				})
			},
			openInfo(content, e) {
				console.log(content)
			}
		},
		mounted() {
			//
			if (this.mode == 0) {
				this.terminalAreaReport()
			} else {
				this.rqsPath()
			}


		},
		watch: {
			'mapdata1.sn'() {
				//
				if (this.mode == 0) {
					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			},
			'mapdata1.page'() {
				//
				if (this.mode == 0) {
					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			},
			'mapdata1.rows'() {
				//this.terminalAreaReport();
				if (this.mode == 0) {
					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			},
			'mapdata1.status'() {
				//this.terminalAreaReport();
				if (this.mode == 0) {
					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			},
			'mapdata1.areaid'() {
				//this.terminalAreaReport();
				if (this.mode == 0) {

					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			},
			'mapdata1.runStatus'() {
				//
				if (mode == 0) {
					this.terminalAreaReport();
				} else {
					this.rqsPath()
				}
			}
		},

		data() {
			return {
				opts: {
					width: 250,
					height: 100,
					title: '',
					enableMessage: true
				},
				opts1: {
					width: 100,
					height: 50,
					title: '',
					enableMessage: true
				},
				mapdata: '',
			}
		},
		props: ['height', 'mapdata1', 'mode']
	}
</script>
<style scoped>
	.box1 {
		width: 100%;
	}

	.map-view {
		width: 100%;
	}

	.term-detail {
		line-height: 25px;
	}
</style>


// WEBPACK FOOTER //
// ztMap.vue?7d69fc27